/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { ProgressTrackerStore } from 'src/core/stores/ProgressTrackerStore';
import { CustomTextTrainedModelStore } from 'src/customText/core/stores/CustomTextTrainedModelStore';

export const useModelsEvaluationData = (models: CustomTextTrainedModelStore[]) => {
    const { dispatcher } = useGlobalState();
    const isLoadingTrackers: ProgressTrackerStore[] = [];

    React.useEffect(() => {
        models.forEach(model => {
            const modelEvalFetchingTracker = new ProgressTrackerStore();
            isLoadingTrackers.push(modelEvalFetchingTracker);

            dispatcher.dispatch('getTrainedModelAllData', {
                toastData: {},
                trainedModelName: model.name,
                tracker: modelEvalFetchingTracker
            });
        });
    }, [models]);

    return { isLoading: isLoadingTrackers.length > 0 && isLoadingTrackers.reduce((acc, item) => acc && item.isRunning, true) };
};
